/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import "./InitialLoadScreen.css";
import { useNavigate } from "react-router-dom";
import loadingGif from "../../assets/gif/app-loader.gif";
import ROUTE_PATHS from "../../utils/routePaths";
import { useStorage } from "services/StorageProvider";

const InitialLoadScreen = () => {
  const navigate = useNavigate();
  const { refreshUserProfile, refreshAppData } = useStorage();

  useEffect(() => {
    refreshUserProfile();
    const timer = setTimeout(() => {
      const storedData = localStorage.getItem("userProfileData");
      if (storedData) {
        refreshAppData();
        const userProfileData = JSON.parse(storedData);
        if (
          userProfileData.first_name &&
          userProfileData.mobile_number
        ) {
          // userProfileData.is_founder
          //   ? navigate(ROUTE_PATHS.WSM_HOME, { replace: true })
          //   : navigate(ROUTE_PATHS.WSM_PROFILE_SETUP_NOT_FOUNDER, {
          //       replace: true,
          //     });
          navigate(ROUTE_PATHS.WSM_HOME, { replace: true })
        } else {
          navigate(ROUTE_PATHS.WSM_PROFILE_SETUP, { replace: true });
        }
      } else {
        navigate(-1);
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="wms-mobile-container">
      <div className="initial-load-screen-container">
        <img
          src={loadingGif}
          alt="Loading..."
          className="initial-load-loader"
        />
        <p className="initial-load-screen-title">Please wait</p>
        <p className="initial-load-screen-sub-title">
          Loading your high-performance zone 🚀
        </p>
      </div>
    </div>
  );
};

export default InitialLoadScreen;
